export const landmarks = [
  { name: "Daytona Beach Intl Airport (DAB)", distance: "~3 miles", icon: "ri-flight-takeoff-line", desc: "Regional airport with direct flights to major Southeast hubs via Delta, American, and seasonal international charters", url: "https://www.flydaytonafirst.com/", schemaType: "Airport" },
  { name: "Orlando International Airport (MCO)", distance: "~70 miles", icon: "ri-flight-takeoff-line", desc: "Major international hub with direct flights to Europe, Latin America, and global destinations — nearest large international airport", url: "https://orlandoairports.net/", schemaType: "Airport" },
  { name: "Daytona International Speedway", distance: "~2 miles", icon: "ri-car-line", desc: "Iconic motorsports venue — Daytona 500, Rolex 24, Bike Week, and Biketoberfest — drawing international visitors year-round", url: "https://www.daytonainternationalspeedway.com/", schemaType: "TouristAttraction" },
  { name: "Daytona Beach Boardwalk & Pier", distance: "Beachfront", icon: "ri-landscape-line", desc: "Historic oceanfront boardwalk with amusement rides, arcades, dining, and the iconic Main Street Pier", url: "https://www.daytonabeach.com/", schemaType: "TouristAttraction" },
  { name: "Ponce Inlet Lighthouse", distance: "~10 miles", icon: "ri-ancient-gate-line", desc: "Florida's tallest lighthouse at 175 feet — National Historic Landmark and museum with panoramic Atlantic views", url: "https://www.ponceinlet.org/", schemaType: "TouristAttraction" },
  { name: "Jackie Robinson Ballpark", distance: "~2 miles", icon: "ri-trophy-line", desc: "Historic minor league stadium on City Island where Jackie Robinson played the first integrated spring training game in 1946", url: "https://www.milb.com/daytona", schemaType: "TouristAttraction" },
  { name: "I-95", distance: "~2 miles", icon: "ri-road-map-line", desc: "Primary East Coast interstate connecting Daytona Beach to Jacksonville, Miami, and all points between", url: "https://en.wikipedia.org/wiki/Interstate_95_in_Florida", schemaType: "CivicStructure" },
  { name: "Tomoka State Park", distance: "~8 miles", icon: "ri-leaf-line", desc: "2,000-acre archaeological and recreational park along the Tomoka River with Native American history and kayaking", url: "https://www.floridastateparks.org/tomoka", schemaType: "TouristAttraction" },
];

export default function DaytonaLocalAreaSection() {
  return (
    <section id="local-area" className="bg-[#F7F8FA] pt-6 pb-20">
      <div className="max-w-5xl mx-auto px-4">
        <div className="text-center mb-10">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Service Area</p>
          <h2 className="font-serif text-3xl font-bold text-[#1A365D] mb-4">Daytona Beach Area</h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Serving Daytona Beach, Port Orange, Ormond Beach, New Smyrna Beach, and all Volusia County communities.
          </p>
        </div>

        {/* Office card */}
        <div className="bg-[#1A365D] rounded-lg p-6 mb-6 text-white">
          <div className="flex items-start gap-4">
            <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#F6C344] flex-shrink-0">
              <i className="ri-passport-line text-[#1A365D] text-lg"></i>
            </div>
            <div className="flex-1">
              <p className="font-bold text-base mb-0.5">Fast Passport Center — Daytona Beach, FL</p>
              <p className="text-white/60 text-xs mb-3">300 N Beach St, Daytona Beach, FL 32114</p>

              {/* Phone Number */}
              <div className="flex items-start gap-2.5 mb-3">
                <div className="w-5 h-5 flex items-center justify-center rounded-full bg-[#F6C344]/15 flex-shrink-0 mt-0.5">
                  <i className="ri-phone-line text-[#F6C344] text-[10px]"></i>
                </div>
                <div>
                  <a href="tel:8772530084" className="text-white/80 text-xs hover:text-[#F6C344] transition-colors">(877) 253-0084</a>
                  <p className="text-white/40 text-[10px]">Nationwide toll-free — 24/7 voicemail</p>
                </div>
              </div>

              {/* Office Hours */}
              <div className="flex items-start gap-2.5 mb-3">
                <div className="w-5 h-5 flex items-center justify-center rounded-full bg-[#F6C344]/15 flex-shrink-0 mt-0.5">
                  <i className="ri-time-line text-[#F6C344] text-[10px]"></i>
                </div>
                <div>
                  <div className="text-white/80 text-xs space-y-0.5">
                    <p className="whitespace-nowrap">Monday – Friday: 9:00 AM – 6:00 PM EST</p>
                    <p className="whitespace-nowrap">Saturday: 10:00 AM – 2:00 PM EST</p>
                    <p className="whitespace-nowrap">Sunday: Closed</p>
                  </div>
                  <p className="text-[#F6C344] text-[11px] mt-1 font-medium">Appointment suggested</p>
                  <p className="text-white/40 text-[10px] mt-0.5">Appointment suggested to ensure your documents are reviewed before you arrive.</p>
                  <p className="text-white/40 text-[10px] mt-1.5">Last updated: July 18, 2026</p>
                </div>
              </div>

              <p className="text-white/80 text-sm leading-relaxed mb-4">
                Visit our Daytona Beach office (appointment suggested), or ship your documents overnight from anywhere in Volusia County — no in-person visit required for most services.
              </p>
              <div className="rounded-md overflow-hidden mb-3" style={{ height: '180px' }}>
                <iframe
                  src="https://maps.google.com/maps?q=300+N+Beach+St+Daytona+Beach+FL+32114&z=15&output=embed"
                  title="Fast Passport Center Daytona Beach Office"
                  className="w-full h-full"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  aria-label="Google Map showing Fast Passport Center Daytona Beach office at 300 N Beach St"
                />
              </div>
              <a
                href="https://fastpassportcenter.com/checkout/"
                className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-sm px-5 py-2.5 rounded-md transition-all whitespace-nowrap"
              >
                Start My Passport <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="bg-white rounded-lg p-7 border border-gray-200">
          <h3 className="font-bold text-[#1A365D] text-sm uppercase tracking-wide mb-5">
            <i className="ri-map-pin-2-line text-[#F6C344] mr-2"></i>
            Cities &amp; Communities We Serve
          </h3>
          <div className="space-y-1.5 mb-6">
            {[
              { name: "Daytona Beach", zips: "32114, 32118" },
              { name: "Port Orange", zips: "32127, 32128, 32129" },
              { name: "Ormond Beach", zips: "32174, 32176" },
              { name: "New Smyrna Beach", zips: "32168, 32169" },
              { name: "Holly Hill", zips: "32117" },
              { name: "South Daytona", zips: "32119" },
              { name: "DeLand", zips: "32720, 32724" },
              { name: "Palm Coast", zips: "32137, 32164" },
            ].map((city, i) => (
              <div key={i} className="flex items-center justify-between py-2.5 px-3 bg-[#F7F8FA] rounded-md">
                <div className="flex items-center gap-2.5">
                  <i className="ri-checkbox-circle-fill text-[#F6C344] text-sm"></i>
                  <span className="text-[#1A365D] font-medium text-sm">{city.name}</span>
                </div>
                <span className="text-gray-400 text-xs font-mono">{city.zips}</span>
              </div>
            ))}
          </div>

          <div className="border-t border-gray-100 pt-5">
            <p className="text-gray-400 text-xs font-semibold uppercase tracking-widest mb-3">Nearby Cities We Serve</p>
            <div className="flex flex-wrap gap-2">
              {[
                { name: "Melbourne", href: "/melbourne" },
                { name: "Orlando", href: "/orlando" },
                { name: "St. Augustine", href: "/st-augustine" },
                { name: "Jacksonville", href: "/jacksonville" },
              ].map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  className="inline-flex items-center gap-1 text-xs text-[#1A365D] hover:text-[#F6C344] font-medium transition-colors bg-[#F7F8FA] border border-gray-200 hover:border-[#F6C344] rounded-full px-3 py-1.5 whitespace-nowrap"
                >
                  {link.name} <i className="ri-arrow-right-line text-[10px]"></i>
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* Nearby Landmarks & Airports */}
        <div className="bg-white rounded-lg p-7 border border-gray-200 mt-6">
          <div className="flex items-center gap-2 mb-4">
            <div className="w-6 h-6 flex items-center justify-center rounded-full bg-[#F6C344]/15">
              <i className="ri-landscape-line text-[#1A365D] text-xs"></i>
            </div>
            <h3 className="font-semibold text-[#1A365D] text-sm uppercase tracking-wide">Nearby Landmarks &amp; Airports</h3>
          </div>
          <div className="flex flex-wrap gap-1.5">
            {landmarks.map((item) => (
              <span
                key={item.name}
                className="inline-flex items-center gap-1.5 bg-[#F7F8FA] border border-gray-200/80 rounded-full px-3 py-1.5 hover:border-[#F6C344] transition-colors cursor-default whitespace-nowrap"
                title={item.desc}
              >
                <i className={`${item.icon} text-[#1A365D] text-[10px]`}></i>
                <span className="text-[#1A365D] font-medium text-[11px]">{item.name}</span>
                <span className="text-[#B22222] font-semibold text-[10px]">{item.distance}</span>
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}